/*=========================================================================================
  File Name: moduleCountryActions.js
  Description: Country Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
 fetchPurchaseOrders({ commit }) {
      return axios.get("/api/PurchaseOrder/GetAll").then(res => {
        commit('SET_PURCHASEORDERS', res.data.Data);
      });
    },

     fetchPurchaseOrderStatus({ commit }) {
      return axios.get("/api/PurchaseOrderStatus/GetAll").then(res => {
        commit('SET_PURCHASEORDERSTATUS', res.data.Data);
      });
    },


fetchFilteredOrders({ commit }, filters) {
  return axios.post("/api/PurchaseOrder/Search", filters)
    .then((response) => {

      commit("SET_PURCHASEORDERS", response.data.Data);
    })
    .catch((error) => { 
      console.error("Search Error:", error); 
    });
},
  removeItem({ commit }, item) {
    
    return new Promise((resolve, reject) => {
      axios.delete(`API/ PurchaseOrder/Delete/${item.Id}`, {
        headers: { Authorization: 'Bearer ' + localStorage.accessToken }
      })
        .then((response) => {
          commit('REMOVE_ITEM', item.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
